
import detailing1 from "./../assets/detailing/01.jpg";
import detailing2 from "./../assets/detailing/02.jpg";


const services = [{
  id: 1,
  title: 'Modelagem 3D',
  desc: "Criação da modelagem 3D a partir de uma planta de layout e/ou imagens de referências, com indicações dos mobiliários, cortes, vistas ou perspectivas esquemáticas e especificação de todos os revestimentos, materiais, eletrodomésticos e mobiliários soltos.",
  type: "modal",
  isIncluded: [
    'Criação da modelagem do zero, a partir da planta de layout/referências;',
    'Texturização e inserção de blocos;',
    'Envio de perspectivas testes para conferência de projeto.'
  ],
  isNotIncluded: [
    'Participação do projeto e criação de ambientes;',
    'Alteração após aprovação e entrega final(caso haja alterações no projeto após a entrega final, podemos combinar um novo valor e prazo de acordo com a quantidade e dificuldade das alterações).'
  ],
  itemsDeliveredByCustomer: [
    'Plantas baixas devidamente cotadas e especificadas, em formato DWG ou RVT;',
    'Cortes/vistas necessários para o desenvolvimento do 3D, em formato DWG ou RVT;',
    'Planta luminotécnica, com indicação de todas as luminárias de teto, parede e piso;',
    'Temperatura de cor desejada para cada luminária;',
    'Caso tenha algum detalhe construtivo importante, mostrar também;',
    'Materiais, revestimentos e eletrodomésticos devidamente especificados;',
    'Se possível, enviar uma imagem do entorno do projeto.',
  ],
  notes: []
},{
  id: 2,
  title: 'Renderização',
  desc: "Imagens e vídeos 3D de forma realista, com tratamento de cores, formas, sombras e texturas.",
  type: "modal",
  isIncluded: [
    'Definição de cenas/ângulos da sua preferência;',
    'Refinamento da modelagem (como redesenhar piso, arredondar bordas e acrescentar alguns detalhes, caso necessário);',
    'Pequenos ajustes de blocos e texturas, caso necessário, para alcançar maior realismo;',
    'Configuração de materiais e iluminação;',
    'Envio das imagens testes em menor qualidade para aprovação;',
    'Imagens finais em alta definição.'
  ],
  isNotIncluded: [
    'Criação da modelagem 3D do zero;',
    'Participação no projeto e criação de ambientes;',
    'Envio do arquivo configurado;',
    'Alteração após aprovação e entrega final (caso haja alterações após a entrega final, podemos combinar um novo valor e prazo de acordo com o número de imagens/ambientes a serem refeitos).'
  ],
  itemsDeliveredByCustomer: [
    'Envio da modelagem 3D em arquivo SKP;',
    'Indicações de revestimentos e acabamentos específicos, para configurar de acordo com o aspecto real do material;',
    'Indicação de fitas de led e iluminação;',
    'Temperatura de cor desejada para as luminárias;',
    'Se possível, enviar uma imagem do entorno do projeto.'
  ],
  notes: []
},
{
  id: 3,
  type: "link",
  href: '/tour-360',
  title: "TOUR 360º E ANIMAÇÕES",
  desc: "Criação de cenas em 360ª que oferecem maior visualização do ambiente, gerando a sensação de amplitude e conexão da pessoa com o projeto. Desenvolvimento de vídeos de ambientes e/ou animações de objetos que ganham vida para encantar e captar seus clientes."
},
{
  id: 4,
  title: 'Detalhamento de interiores',
  desc: "Desenvolvimento do detalhamento executivo de interiores para facilitar e agilizar sua rotina em escritório de arquitetura e design de interiores.",
  type: "modal",
  isIncluded: [
    'Criação, a partir do projeto 3D finalizado, de plantas baixas, layout, vistas e detalhes;',
    'Especificação de todos os materiais/revestimentos, acabamentos, mobiliários fixos e soltos e decoração;',
    'Dimensões exatas de todos os mobiliários fixos;',
    'Envio do arquivo prévio das pranchas, em PDF, para correção/aprovação;',
    'Envio final do arquivo, em alta qualidade, em PDF.'
  ],
  isNotIncluded: [
    'Criação da modelagem 3D do ambiente a ser detalhado;',
    'Participação no projeto e criação de ambientes;',
    'Envio do arquivo configurado (SketchUp e Layout);',
    'Responsabilidade sobre o projeto, acabamentos, mobiliários e/ou execução;',
    'Alterações após a entrega final.'
  ],
  itemsDeliveredByCustomer: [
    'A modelagem 3D em arquivo SKP;',
    'Informações de móveis soltos, pintura, marcenaria, marmoraria, eletrodomésticos e todos os itens necessários;',
    'Materiais e revestimentos devidamente especificados.'
  ],
  images: [detailing1, detailing2],
  notes: [
    'O detalhamento será criado por ambiente, devido a capacidade do Layout;',
    'O tamanho da folha é da sua preferência;',
    'É importante que envie o template Layout (caso possua), um modelo seu de detalhamento, para seguir o mesmo padrão, capa e carimbo de preferência, com sua logo. Caso não possua template, modelo de detalhamento, capa e carimbo, será utilizado um modelo padrão criado pela Susan Groth.'
  ]
},
// {
//   id: 5,
//   type: "link",
//   href: '/#contact',
//   "title": "PROJETO DE INTERIORES",
//   "desc": "Criação de espaços que atendam as necessidades e desejos de cada cliente. Transformação de um lugar que seja funcional e esteticamente agradável, refletindo a personalidade e estilo de vida."
// }
]

export default services;
  